// extracted by mini-css-extract-plugin
export var cancelButton = "_o1-5";
export var content = "_o1-3";
export var createButton = "_o1-6";
export var drawerContainer = "_o1-0";
export var footer = "_o1-2";
export var header = "_o1-1";
export var orderFormColumn = "_o1-4";